const emailAccountTypes = {
  gmail: {
    id: 1,
    description: 'gmail',
  },
  outlook: {
    id: 2,
    description: 'outlook',
  },
  exchange: {
    id: 3,
    description: 'office365',
  },
  imap: {
    id: 4,
    description: 'imap',
  }
};

export default emailAccountTypes;
